const errorMessage_ar = async (errorCode, requestContent) => {

    const message = {
        success: 'تم بنجاح!',
        error: 'خطأ!',
        warning: 'تحذير!',
        authUser: 'المستخدم غير مصادق عليه.',
        bannerSetting: 'تم تحديث تغييرات عنوان الشعار!',
        docVerify: 'تم تغيير حالة المستندات!',
        cancelInfo: 'تم تحديث تغييرات معلومات الإلغاء!',
        addWishlist: 'تمت إضافة قائمة الرغبات بنجاح.',
        updateWishList: 'تم تحديث قائمة الرغبات بنجاح.',
        cancelInfoError: 'فشل تحديث معلومات الإلغاء.',
        bannerSettingError: 'فشل تحديث إعدادات الشعار.',
        verifyPhoneNumber: 'تم التحقق من رقم الهاتف بنجاح.',
        validateNumber: 'تعذر التحقق من رقم هاتفك. يرجى المحاولة مرة أخرى.',
        isListingAvailable: 'القائمة غير متاحة.',
        cardError: 'عذرًا، حدث خطأ ما في بطاقتك. يرجى المحاولة مرة أخرى.',
        requestError: 'طلب غير صالح.',
        birthDayField: 'حقل يوم الميلاد مفقود.',
        birthYearField: 'حقل سنة الميلاد مفقود.',
        birthMonthField: 'حقل شهر الميلاد مفقود.',
        noRecord: 'لم يتم العثور على سجلات.',
        createFailed: 'فشل الإنشاء.',
        addPopularLocation: 'تمت إضافة الموقع بنجاح!',
        invalidUrl: 'رابط الصفحة موجود بالفعل!',
        addBlogDetails: 'تم إنشاء صفحة المحتوى بنجاح!',
        updateBlogDetails: 'تم تحديث صفحة المحتوى بنجاح!',
        isUpdated: 'لم يتم التحديث.',
        zipCode: 'الرمز البريدي الخاص بك غير مكتمل.',
        updateConfigSettings: 'تم تحديث الإعدادات بنجاح!',
        inActivePayment: 'لا يمكنك إلغاء تفعيل نوع الدفع هذا لأنه قيد الاستخدام حاليًا.',
        isAllow: 'يجب تفعيل خيار واحد على الأقل.',
        noAccountExist: 'لا يوجد حساب مرتبط بعنوان البريد الإلكتروني المقدم.',
        userBanStatus: 'عذرًا! يبدو أن حسابك معطل حاليًا. يرجى الاتصال بالدعم.',
        isExistAdminRole: 'عذرًا، تعذر العثور على دور المسؤول هذا.',
        adminUser: 'عذرًا! تعذر حذف دور المسؤول لأنه قيد الاستخدام من قبل بعض المستخدمين.',
        updateReview: 'عذرًا! حدث خطأ ما. تعذر تحديث المراجعة. يرجى المحاولة مرة أخرى لاحقًا.',
        findActiveReservation: 'عذرًا! تعذر حذف هذا المستخدم. يبدو أن المستخدم لديه حجوزات نشطة/قادمة ويجب عليه إلغاء أو إكمال الحجوزات لحذف الحساب.',
        adminLogin: 'عذرًا! يرجى تسجيل الدخول كمستخدم مسؤول والمحاولة مرة أخرى.',
        fetchRecord: 'حدث خطأ أثناء جلب السجلات. يرجى المحاولة مرة أخرى.',
        loginError: 'أنت غير مسجل الدخول، يرجى تسجيل الدخول والمحاولة مرة أخرى!',
        createListPhoto: 'تم تحميل صورة القائمة بنجاح!',
        removeListPhoto: 'لا يمكنك إزالة الصور حيث أن لديك حجوزات أو استفسارات قادمة لهذه القائمة.',
        resendVerifyEmail: 'تم إرسال رابط التأكيد إلى بريدك الإلكتروني.',
        resentEmailError: 'فشل إرسال البريد الإلكتروني. يرجى المحاولة مرة أخرى لاحقًا.',
        upcomingBooking: 'عذرًا، لا يمكنك حذف هذه العقار، لديه حجوزات أو استفسارات قادمة.',
        invalidAddress: 'يبدو أن عنوانك غير صحيح، يرجى العودة لتعديل العنوان!',
        holdPayoutSuccess: 'تم تحديث حالة الاحتفاظ بالدفع بنجاح.',
        holdPayoutError: 'فشل تغيير حالة الاحتفاظ بالدفع.',
        paypalError: 'العملة التي اخترتها غير مدعومة من قبل PayPal. يرجى تغيير العملة والمحاولة مرة أخرى.',
        forgotPasswordLink: 'تم إرسال رابط لإعادة تعيين كلمة المرور إلى بريدك الإلكتروني.',
        changeForgotPassword: 'تم تغيير كلمة المرور الخاصة بك. يمكنك الآن محاولة تسجيل الدخول.',
        deleteCalendar: `التقويم المتزامن "${requestContent}" تم حذفه بنجاح.`,
        deleteCalendarError: `فشل في حذف التقويم المتزامن "${requestContent}".`,
        importCalendar: 'تمت إضافة التقويم بنجاح! بدأت عملية مزامنة التقويم!',
        existImportCalendar: 'تم استيراد التقويم بالفعل!',
        invalidCalendar: 'تقويم غير صالح! الرابط غير صحيح، وفشل استيراد التقويم.',
        unPublish: 'لا يمكنك إلغاء النشر حيث أن لديك حجوزات أو استفسارات قادمة لهذه القائمة.',
        createListing: 'تم تقديم القائمة للموافقة.',
        actionFailed: 'فشل الإجراء!',
        listApprovalStatus: 'تم رفض طلب مراجعة القائمة بنجاح.',
        listingApprove: 'تمت الموافقة على القائمة بنجاح!',
        contactHostError: 'لقد طلبت بالفعل في هذا التاريخ.',
        contactHost: 'تم إرسال طلبك!',
        sendMessageError1: 'عذرًا! لقد قمت بهذا الإجراء بالفعل!',
        sendMessageError2: 'عذرًا! لقد وافقت بالفعل على هذا لاستخدام آخر.',
        cancelReservation: 'تم إلغاء الحجز بنجاح.',
        cancelReservationError: 'يبدو أن حجزك تم تحديثه بالفعل!',
        paymentToHost: 'تم تحويل الدفع إلى المضيف بنجاح!',
        paymentToHostError: 'فشل تحويل الدفع إلى المضيف، يرجى المحاولة بعملة مختلفة.',
        refundToGuest: 'تم تحويل الدفع إلى الضيف بنجاح!',
        refundToGuestError: 'فشل تحويل الدفع إلى الضيف، يرجى المحاولة بعملة مختلفة.',
        updateServiceFee: 'تم تحديث رسوم الخدمة بنجاح!',
        updateServiceFeeError: 'فشل تحديث رسوم الخدمة.',
        deleteSuccess: 'تم الحذف بنجاح.',
        deleteFailed: 'فشل الحذف!',
        updateStatus: 'تم تغيير الحالة.',
        updateFailed: 'فشل تغيير الحالة.',
        updatePopularLocation: 'تم تغيير حالة الموقع.',
        updateLocationError: 'فشل تغيير حالة الموقع.',
        updateWhyHost: 'تم تحديث تغييرات صفحة "لماذا تصبح مضيفًا"!',
        deleteListSetting: 'تم حذف الإعداد بنجاح.',
        deleteSettingError1: 'تعذر حذف إعداد القائمة. يجب أن يكون هناك إعداد قائمة واحد على الأقل متاحًا للعقارات.',
        deleteSettingError2: 'تعذر حذف إعداد القائمة. يتم استخدام إعداد القائمة في العقار. يرجى إزالة إعداد القائمة من العقارات والمحاولة مرة أخرى.',
        addBanner: 'تم تحميل الصورة بنجاح!',
        updateBanner: 'تم تحديث التغييرات بنجاح!',
        updateBanStatus: 'تم تحديث حالة المستخدم بنجاح.',
        updateBanError: 'فشل تحديث حالة الحظر.',
        updateBanWarning: 'يجب عليك اختيار خيار واحد إما السماح أو المنع.',
        paymentGateway: 'تم تحديث الحالة بنجاح!',
        updateStaticPage: 'تم تحديث صفحة المحتوى الثابت بنجاح!',
        updateStaticPageError: 'فشل تحديث صفحة المحتوى الثابت.',
        deleteUser: 'تم حذف المستخدم بنجاح.',
        deleteReview: 'تم حذف المراجعة بنجاح.',
        updateReview: 'تم تحديث المراجعة بنجاح!',
        deleteReviewError: 'فشل حذف المراجعة.',
        deleteAdminRole: 'تم حذف دور المسؤول بنجاح.',
        deleteAdminUser: 'تم حذف مستخدم المسؤول بنجاح.',
        updatePolicy: 'تم تحديث السياسة بنجاح!',
        disableBaseCurrency: 'عذرًا، لا يمكنك تعطيل العملة الأساسية. حاول تعيين عملة أساسية مختلفة وتعطيل هذه العملة.',
        currencyStatus: 'تم تغيير حالة العملة!',
        currencyStatusError: 'فشل تغيير حالة العملة.',
        baseCurrency: 'تم تعيين العملة الأساسية بنجاح.',
        baseCurrencyError: 'فشل تعيين العملة الأساسية.',
        PaymentCurrency: 'تم إجراء تغييرات عملة الدفع.',
        PaymentCurrencyError: 'فشل تغيير حالة عملة الدفع.',
        addRecommend: 'تمت إضافة القائمة إلى القائمة الموصى بها.',
        removeRecommend: 'تمت إزالة القائمة من القائمة الموصى بها.',
        fileTypeError: 'أنت تحاول تحميل ملف صورة غير صالح. يرجى تحميل ملفات الصور بتنسيق PNG أو JPG أو JPEG.',
        limitError: 'تم تجاوز الحد الأقصى لحجم التحميل! حاول استخدام صورة بحجم أصغر.',
        isAdmin: 'أنت مسجل الدخول كمسؤول، لا يمكنك تنفيذ هذا الإجراء!',
        updateFaq: 'تم تحديث تغييرات الأسئلة الشائعة!',
        updateFaqError: 'فشل تحديث تغييرات الأسئلة الشائعة.',
        updateWhyHostPage: 'تم تحديث قسم الاقتباس في صفحة "لماذا تصبح مضيفًا"!',
        updateWhyHostError: 'فشل تحديث إعدادات "لماذا تصبح مضيفًا".',
        updateHostPage: 'تم تحديث تغييرات شعار صفحة "لماذا تصبح مضيفًا"!',
        updateHostPageError: 'فشل تحديث تغييرات شعار صفحة "لماذا تصبح مضيفًا".',
        updateBlock4: 'تم تحديث إعدادات الكتلة 4 في صفحة "لماذا تصبح مضيفًا"!',
        updateBlockError: 'فشل تحديث إعدادات الكتلة 4 في صفحة "لماذا تصبح مضيفًا".',
        updateBlock3: 'تم تحديث إعدادات الكتلة 3 في صفحة "لماذا تصبح مضيفًا"!',
        updateBlockError3: 'فشل تحديث إعدادات الكتلة 3 في صفحة "لماذا تصبح مضيفًا".',
        uploadImage: 'يرجى تحميل الصورة!',
        updateBlock1: 'تم تحديث إعدادات الكتلة 1 في صفحة "لماذا تصبح مضيفًا"!',
        updateBlockError1: 'فشل تحديث إعدادات الكتلة 1 في صفحة "لماذا تصبح مضيفًا".',
        approved: 'لقد وافقت بالفعل.',
        userReviewError: 'فشل تغييراتك على مراجعة المسؤول.',
        invalidId: 'معرف القائمة غير متاح.',
        uploadBlockImage: 'يرجى تحميل صورة الكتلة!',
        updateStaticBlock: 'تم تحديث تغييرات إعدادات الكتلة الثابتة.',
        updateStaticError: 'فشل تغييرات معلومات الكتلة الثابتة.',
        updateSiteSettings: 'تم تحديث تغييرات إعدادات الموقع!',
        updateSettingsError: 'فشل تحديث تغييرات إعدادات الموقع.',
        updateSearchSettings: 'تم تحديث تغييرات إعدادات البحث!',
        searchSettingError: 'فشل تحديث إعدادات البحث.',
        updatePayment: 'تم تحديث إعدادات الدفع!',
        paymentSettingError: 'فشل تحديث إعدادات الدفع.',
        updateListSettings: 'تم تحديث إعداد القائمة بنجاح!',
        disableListSettings: 'تعذر تعطيل إعداد القائمة. يجب أن يكون هناك إعداد قائمة واحد على الأقل نشطًا.',
        listingUsed: 'تعذر تعطيل إعداد القائمة. يتم استخدام إعداد القائمة في العقار. يرجى إزالة إعداد القائمة من العقارات والمحاولة مرة أخرى.',
        addListSettings: 'تم إنشاء إعداد القائمة بنجاح!',
        addListingError: 'فشل إنشاء إعداد القائمة.',
        commandReason: 'يرجى إضافة سبب صالح.',
        alreadyApprove: 'لقد وافقت بالفعل.',
        footerSetting: 'تم تحديث تغييرات إعدادات التذييل!',
        footerSettingError: 'فشل تحديث إعدادات التذييل.',
        updateUser: 'تم تحديث تغييرات الملف الشخصي.',
        addContent: 'يرجى إضافة محتوى.',
        addTitle: 'يرجى إضافة عنوان وصف.',
        addDescription: 'يرجى إضافة وصف وصف.',
        uploadLocImage: 'يرجى تحميل صورة الموقع.',
        updateLocation: 'تم تحديث تغييرات الموقع!',
        updateLocationError: 'فشل تحديث الموقع.',
        adminRemoveListing: 'تمت إزالة القائمة بنجاح.',
        sendEmail: 'تم إرسال بريدك الإلكتروني.',
        listSettingsData: 'عذرًا! تعذر العثور على إعدادات القائمة. يرجى المحاولة مرة أخرى.',
        cancelBooking: 'لقد ألغيت الحجز بالفعل.',
        checkAvailableDates: 'التواريخ غير متاحة!',
        isListingAvailable: 'تم إلغاء نشر القائمة أو حذفها من قبل المضيف/المسؤول. يرجى الاتصال بالمسؤول لمزيد من المعلومات.',
        checkUser: 'عذرًا! المستخدم مختلف.',
        updateCancelPolicy: 'حدث خطأ ما! تعذر التحديث!',
        existEmail: 'عذرًا! عنوان البريد الإلكتروني هذا موجود بالفعل.',
        invalidRoleId: 'عذرًا، يبدو أن الدور المختار غير صالح. يرجى المحاولة بدور صالح آخر.',
        passwordMismatch: 'عدم تطابق كلمة المرور. يرجى المحاولة مرة أخرى.',
        changePassword: 'تم تحديث كلمة المرور بنجاح!',
        wrongPassword: 'كلمة المرور الحالية خاطئة، يرجى المحاولة مرة أخرى!',
        wrongConfirmPassword: 'كلمة المرور التأكيدية غير مطابقة لكلمة المرور الجديدة!',
        invalidSpecPrice: 'السعر الخاص غير صالح.',
        removeDocList: 'تمت إزالة المستند بنجاح!',
        uploadDocument: 'تم تحميل المستند بنجاح!',
        missingField: 'يبدو أنك فاتتك بعض الحقول المطلوبة. يرجى ملؤها.',
        ageLimit: 'عذرًا، يجب أن تكون عمرك 18 عامًا على الأقل.',
        invalidDob: 'تاريخ الميلاد غير صالح، يرجى إدخال بيانات صحيحة.',
        changeAdminUser: 'تم تغيير تفاصيل وصول المسؤول بنجاح!',
        changeUserError: 'فشل تغييراتك على تفاصيل وصول المسؤول.',
        updateProfile: 'تم تحديث ملفك الشخصي بنجاح.',
        invalidEmail: 'البريد الإلكتروني موجود بالفعل، يرجى تجربة عنوان بريد إلكتروني آخر.',
        isPublished: 'عذرًا! لا يمكنك التوصية بالقائمة غير المنشورة.',
        sendSMTPEmail: 'عذرًا! حدث خطأ ما. تعذر إرسال البريد الإلكتروني.',
        stripeTokenError: 'عذرًا! تعذر متابعة الإجراء المطلوب. يرجى المحاولة مرة أخرى.',
        otpError: 'يرجى المحاولة مرة أخرى بعد دقيقتين لتلقي رمز OTP جديد.',
        pageReload: 'حدث خطأ ما، يرجى إعادة تحميل الصفحة والمحاولة مرة أخرى.',
        userExist: 'عذرًا، المستخدم غير موجود في قاعدة البيانات.',
        removeFiles: 'تمت إزالة الملفات بنجاح.',
        removeFilesError: 'لم يتم حذف الملفات.',
        templateMissing: 'عنوان الإيصال أو نوع القالب مطلوب.',
        existFileName: 'اسم الملف غير موجود.',
        paymentCompleted: 'تم إكمال الدفع لهذا الحجز بالفعل.',
        adminUserLogged: 'يبدو أنك قد سجلت الدخول بالفعل كمستخدم مسؤول. يُرجى تسجيل الخروج من لوحة تحكم الموقع ثم المحاولة مرة أخرى.',
        ogImageError: 'يُرجى تحميل صورة OG.',
        offlineError: 'أنت غير متصل بالإنترنت. يُرجى المحاولة مرة أخرى لاحقًا.',
        datesNotAvailable: 'هذه التواريخ غير متاحة. يُرجى المحاولة مرة أخرى بتواريخ مختلفة.',
        adminReviewError: 'لا يمكنك التوصية بهذه القائمة الآن لأنها لم تُنشأ بالكامل.',
        isAgreePhoneNumberError: 'يُرجى تحديد مربع التحقق من التحقق عبر الرسائل النصية القصيرة وحفظ التفاصيل.',
        updateEditProfile: 'تم تحديث التغييرات بنجاح.',
        deleteAccountError: 'لا يمكنك حذف حسابك لأن لديك حجوزات نشطة حاليًا.',
        deleteUserAccount: 'تم حذف حسابك بنجاح.',
        smtpActiveStatus: 'تم تحديث الحالة بنجاح!',
        deleteSmtpData: 'تم حذف بيانات SMTP بنجاح.',
        deleteSmtpDataError: 'لا يمكنك حذف بيانات SMTP النشطة.',
        holdRefundSuccess: 'تم تحديث حالة تعليق الاسترداد بنجاح.',
        holdRefundError: 'فشل في تغيير حالة تعليق الاسترداد.',
        hostServiceFeeGreater: 'لا يمكنك بدء الحجز للتواريخ المحددة بسبب بعض أخطاء التسعير. يُرجى التواصل مع المسؤول للحصول على مزيد من المعلومات.',
        addSmtpData: `تمت إضافة بيانات SMTP بنجاح!`,
        updatedSmtpData: `تم تحديث بيانات SMTP بنجاح!`,
        commonError: requestContent || 'حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقًا.',
        writeAdminReview: `تم ${requestContent ? 'تحديث' : 'تقديم'} تفاصيل مراجعة المسؤول بنجاح!`,
        writeUserReview: `تم ${requestContent ? 'تحديث' : 'تقديم'} تفاصيل مراجعة المستخدم بنجاح!`,
        addAdminRole: `تم ${requestContent == 'add' ? 'وأضاف' : 'تم تحديثه'} دور المسؤول بنجاح!`,
        catchError: `حدث خطأ ما! ${requestContent}`,
        publishSuccess: `تم ${requestContent == 'Publish Listing' ? 'نشر' : 'إلغاء نشر'} القائمة بنجاح.`,
        restrictStaticPageDisable: "عذرًا، غير مسموح لك بتعطيل هذا الحقل.",
        payoutCurrencySuccess: 'تم تحديث عملة الدفع بنجاح',
        payoutCurrencyFailed: 'لا يُسمح لك بتحديث عملة الدفع المفضلة',
        cantDisablePayoutCurrency: 'لا يمكنك تعطيل هذه العملة لأنها عملة الدفع المفضلة. يرجى تعيين عملة مختلفة كعملة الدفع المفضلة قبل تعطيل هذه العملة',
        checkTermsAndPolicy: `يرجى الاطلاع على شروط الخدمة وسياسة الخصوصية للمتابعة.`,
        documentsApproved: `تمت الموافقة على الوثائق!`,
        documentsRejected: `لقد تم رفض الوثائق!`,
        accountDeleteError: `تم حذف حسابك بنجاح. يُرجى التواصل مع الدعم الفني للحصول على المساعدة.`,
        accountBanError: `تم حظر حسابك من قِبل الإدارة. يُرجى التواصل مع الدعم الفني للمساعدة.`,
        demoWarning: `عذراً، لا يُسمح لك بتغيير أو إزالة معلومات العرض التوضيحي.`,
        disableDemo: `تم تعطيل هذا الإجراء على الموقع التجريبي.`,
        settingUpdateSuccess: `تم تطبيق تغييرات إعدادات الموقع بنجاح`,
        documentChangeWarning: `تمت الموافقة على المستندات ولا يمكن تعديلها بعد الآن.`,
        checkTermsAndPolicyPaymentForm: `عفواً! يُرجى الموافقة على الشروط والأحكام للمتابعة.`
    }
    return message[errorCode]

}
export default errorMessage_ar;